import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const brandonConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Brandon Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Brandon, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_brandon',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Brandon',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Brandon Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve one of Hillsborough County's 
     largest communities <strong>Brandon</strong> with expert, dependable tree 
     care. From established older neighborhoods with towering oaks to newer 
     subdivisions where trees are rapidly maturing near homes and fences, Brandon 
     has no shortage of tree hazards that require professional attention. Our team 
     handles the tough jobs other companies avoid.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong> 
     large overhanging limbs threatening rooftops and driveways, storm weakened 
     trunks, trees leaning from saturated soil after heavy rains, and full 
     removals on tight residential lots. We do the job right and leave your 
     property clean.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Brandon</strong> and the surrounding 
     <strong>East Hillsborough County</strong> area protecting your property 
     and keeping your trees healthy through every storm season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Brandon, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Brandon = () => <LocationPage config={brandonConfig} />;
export default Services_Brandon;
